import axios from "axios";
import { commonInterceptor } from "./interceptor";


const API_URL = process.env.REACT_APP_API_BASE_URL;

const commonService = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30-second timeout to prevent indefinite hanging
  // withCredentials: true, // Fix for C-AUTH-01: sends/receives HttpOnly Secure cookies
  
  // Axios built-in CSRF reading
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

commonService.interceptors.request.use(commonInterceptor);

export default commonService;
